import { redirect } from 'shared/helpers/redirect';
// For safety while we are developing the homepage
// we intercept any call to homepage here and force a page refresh.
// This should be removed once it's live.
export const handleHomepageRouting = (url: string) => {
    const splitUrl = url.split('?');
    const [mainUrl] = splitUrl;

    const isHomepageRoute = mainUrl === '/';

    if (isHomepageRoute) {
        redirect(url);
    }
};
